import * as React from "react";
import { styled } from "@mui/material";
import lottieThanksAnimationData from "../../assets/lootie-animations/thank_you_page_animation.json";
import Lottie from "react-lottie";

//region [[ Styles ]]

const ThankYouAnimationView = styled("div")({});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ThankYouAnimationProps {
  className?: string;
  size: number;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ThankYouAnimation = ({ ...props }: ThankYouAnimationProps) => {
  const size = props.size || 300;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lottieThanksAnimationData,
    controls: false,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <ThankYouAnimationView className={props.className}>
      <Lottie options={defaultOptions} height={size} width={size} />
    </ThankYouAnimationView>
  );
};
